import {AfterViewInit, Component, ElementRef, HostListener, Input, OnInit} from '@angular/core';
import {properties} from "../../../../../../environments/properties";
import {AuthService} from "../../../../../shared/services/auth.service";
import {Router} from '@angular/router';

@Component({
    selector: 'app-partner-card-V2',
    templateUrl: './partner-card-V2.component.html',
    styleUrls: ['./partner-card-V2.component.scss']
})
export class PartnerCardComponentV2 implements OnInit, AfterViewInit {

    @Input() partner: any;
    @Input() appHostURL: any;
    @Input() currentEnvironment: string;
    @Input() userInfo: any;
    @Input() banner: any;
    @Input() isLoggedInTokenValid: any;
    public sm = '575px';
    public md = '768px';
    public imagePath: string;
    scrWidth: any;
    viewPort = 'desktop';

    constructor(public elementRef: ElementRef, public authService: AuthService, private router: Router) {

    }

    ngOnInit(): void {
        this.imagePath = properties.rewardsConfig.imagePath;
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
        this.scrWidth = window.innerWidth;
        if (this.scrWidth >= 768) {
            this.viewPort = 'desktp';
        } else {
            this.viewPort = 'moobile';
        }
        const btnElement = this.elementRef.nativeElement.querySelector('.partner-image');
        if (btnElement) {
            btnElement.style.backgroundImage = this.getImageUrl(this.viewPort);
            btnElement.style.backgroundRepeat = 'no-repeat';
            btnElement.style.backgroundSize = '100% 100%';
        }
    }

    ngAfterViewInit() {
        const btnElement = this.elementRef.nativeElement.querySelector('.partner-image');
        if (btnElement) {
            btnElement.style.backgroundImage = this.getImageUrl(this.viewPort);
            btnElement.style.backgroundRepeat = 'no-repeat';
            btnElement.style.backgroundSize = '100% 100%';
        }
    }

    public getImageUrl(viewport: string): string {
        let imageRef = '';
        let imgPath = '';
        if (this.partner && this.partner.bgImgPath) {
            const modifiedImagePath = this.partner.bgImgPath.replace(/\$.*/, '');
            if (viewport === 'desktop') {
                imgPath = '?$partner-cards-desktop$&defaultImage=Not_Available';
            } else {
                imgPath = '?$partner-cards-tablet$&defaultImage=Not_Available';
            }

            imageRef = 'url(' + modifiedImagePath + imgPath + ')'
        }
        return imageRef;
    }

    public openPartnerDetailPage(event) {
        if (this.isLoggedInTokenValid) {
            const storageData =
                {
                    partnerName: this.partner.partnerName,
                    contentPath: this.partner.contentPath,
                    partnerOfferId: this.partner.partnerOfferId,
                    isStatic:	this.partner.isStatic,
                    staticPromo: this.partner.staticPromo ? this.partner.staticPromo : null,
                    userInfo: this.userInfo,
                    partnerExternalUrl: this.partner.partnerExternalUrl
                }
            localStorage.setItem('partnerDetails', JSON.stringify(storageData));
            this.router.navigate(['rewards/partner-detail']);
        } else {
            this.authService.redirectToSSO(this.userInfo.tokenObject);
        }

    }
}
